import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/navbar.css";
import logo from "../images/logo.png";

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  // Helper function to highlight the active link
  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  // Toggle the mobile menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close the menu when a link is clicked
  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="flat-nav">
      <div className="nav-brand">
        <Link to="/" onClick={closeMenu}>
          {/* 2. Replace the text with the img tag */}
          <img src={logo} alt="CITB Booking Logo" className="nav-logo" />
        </Link>
      </div>

      {/* Hamburger Icon */}
      <div className={`hamburger ${isOpen ? "open" : ""}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Navigation Links */}
      <div className={`nav-links ${isOpen ? "open" : ""}`}>
        <Link to="/" className={isActive("/")} onClick={closeMenu}>
          Home
        </Link>
        <Link to="/about" className={isActive("/about")} onClick={closeMenu}>
          About The Course
        </Link>
        <Link
          to="/booking"
          className={isActive("/booking")}
          onClick={closeMenu}
        >
          Book Now
        </Link>
        <Link
          to="/contactus"
          className={isActive("/contactus")}
          onClick={closeMenu}
        >
          Contact Us
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
